import React, { createContext, useContext, ReactNode } from 'react';
import { useWatchlist } from '@/hooks/useWatchlist';
import type { WatchedDomain, WatchedSnapshot } from '@/lib/watchlistStorage';
import type { DomainChange } from '@/hooks/useWatchlist';

type WatchlistContextType = ReturnType<typeof useWatchlist>;

const WatchlistContext = createContext<WatchlistContextType | undefined>(undefined);

export const WatchlistProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const value = useWatchlist();
  return <WatchlistContext.Provider value={value}>{children}</WatchlistContext.Provider>;
};

export function useWatchlistContext(): WatchlistContextType {
  const ctx = useContext(WatchlistContext);
  if (!ctx) throw new Error('useWatchlistContext must be used within WatchlistProvider');
  return ctx;
}

export type { WatchedDomain, WatchedSnapshot, DomainChange };
